import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import {
    convertPetRewardListFromStrings,
    convertPetRewardListToStrings,
    useMixins
} from '@/modules/picword/pet/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';

export function usePicwordPetEdit() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { v$, rewardV$, model, SelectableBooster } = useMixins();

    const fetch = crudAction.executeAction({
        request: () => picwordService.pet.get(model.id),
        onSuccess: ({ data }) => {
            model.rewardList = convertPetRewardListFromStrings(
                data.experienceByLevel,
                data.creditReward,
                data.heartReward,
                data.boosterReward
            );

            Object.assign(model, data);
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const reward = convertPetRewardListToStrings(model.rewardList);
                return picwordService.pet.update(
                    model.id,
                    model.interactiveSeconds,
                    model.gachaWeights,
                    model.totalLevel,
                    reward.experienceByLevels,
                    reward.creditRewards,
                    reward.heartRewards,
                    reward.boosterRewards
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.PET.INDEX })
        })
    };

    return { model, v$, rewardV$, fetch, actions, SelectableBooster };
}
